// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { push } from 'react-router-redux'

const goToAFSResultsFilter = () => (dispatch, getState) => {
  const projectId = getState().projectSummary.get('projectId')
  return dispatch(push(`/project-management/${projectId}/interference-analysis/result-filter`))
}

export default goToAFSResultsFilter
